import { render, staticRenderFns } from "./EditCollection.vue?vue&type=template&id=06576ef6"
import script from "./EditCollection.vue?vue&type=script&lang=js"
export * from "./EditCollection.vue?vue&type=script&lang=js"
import style0 from "./EditCollection.vue?vue&type=style&index=0&id=06576ef6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports